export const VocabPhoneWidget = {
  number: ['Número de teléfono', 'Phone number'],
  incomplete_number: ['Número incompleto', 'Incomplete number'],
};

export type VocabPhoneWidgetKey = keyof typeof VocabPhoneWidget;
export default VocabPhoneWidget;